import React from 'react';
import MultiSelect from '../ui/MultiSelect';
import { PROJECT_SITUATION_FILTERS } from '../../domain/projects';

function ProjectSituationFilter({ selectedSituations, onSituationsChange }) {
  return (
    <MultiSelect
      label="Filtrar por situação atual do projeto"
      values={selectedSituations}
      options={PROJECT_SITUATION_FILTERS}
      emptyLabel="Todas as situações"
      onChange={onSituationsChange}
    />
  );
}

export default ProjectSituationFilter;
